import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { PaymentStatus, setPaymentStatus } from '@/store/slices/paymentSlice';

export const usePayment = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((store) => store.payment);

  const updateStatus = (status: PaymentStatus) => {
    dispatch(setPaymentStatus(status));
  };

  const resetStatus = () => {
    dispatch(setPaymentStatus("idle"));
  }

  return {
    paymentStatus: status,
    updatePaymentStatus: updateStatus,
    resetPaymentStatus: resetStatus,
  };
};
